import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Meteor } from 'meteor/meteor';

const { productName, twitterUsername, productTwitterUser } = Meteor.settings.public;

const seoImageURL = () => `https://137.74.44.166/ias-logo/srm.png`;
const seoURL = path => Meteor.absoluteUrl(path);

const SEO = ({
  schema,
  title,
  description,
  images,
  path,
  contentType,
  published,
  updated,
  category,
  tags
}) => (
  <Helmet>
    <html lang="en" itemScope itemType={`https://schema.org/${schema}`} />

    <title>{title}</title>
    <meta name="description" content={description} />
    <meta itemProp="name" content={title} />
    <meta itemProp="description" content={description} />
    <meta itemProp="image" content={(images && images.google) || seoImageURL()} />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content={`@${productTwitterUser}`} />
    <meta name="twitter:title" content={`${title}`} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:creator" content={`@${twitterUsername}`} />
    <meta name="twitter:image:src" content={(images && images.twitter) || seoImageURL()} />

    <meta property="og:title" content={`${title} | ${productName}`} />
    <meta property="og:type" content={contentType} />
    <meta property="og:url" content={seoURL(path)} />
    <meta property="og:image" content={(images && images.facebook) || seoImageURL()} />
    <meta property="og:description" content={description} />
    <meta property="og:site_name" content={productName} />

    <meta name="fb:app_id" content="" />

    {published && <meta name="article:published_time" content={published} />}
    {updated && <meta name="article:modified_time" content={updated} />}
    {category && <meta name="article:section" content={category} />}
    {tags && <meta name="article:tag" content={tags} />}
  </Helmet>
);

SEO.defaultProps = {
  schema: null,
  path: null,
  updated: null,
  category: null,
  tags: [],
  images: {}
};

SEO.propTypes = {
  schema: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  path: PropTypes.string,
  contentType: PropTypes.string.isRequired,
  published: PropTypes.string.isRequired,
  updated: PropTypes.string,
  category: PropTypes.string,
  tags: PropTypes.array,
  images: PropTypes.object
};

export default SEO;
